import classnames from 'classnames';
import BackButton from 'components/common/BackButton';
import React from 'react';
import styles from './styles.scss';

interface Props {
  statusCode: number;
}

const ErrorPage = ({ statusCode }: Props): JSX.Element => {
  const description = statusCode === 404 ? 'Denne siden finnes ikke.' : 'Det har skjedd en feil. Vi jobber med saken!';
  const isNylander = typeof document !== 'undefined' && document.referrer && /.*nylander\.no/.test(document.referrer);
  return (
    <div className={classnames(styles.error, isNylander ? styles.error_nylander : null)}>
      <h1 className={styles.title}>Oops, det var flaut.</h1>
      <p>{description}</p>
      <small>Feilnummer: {statusCode}</small>
      <BackButton className={styles.back} text="Til startsiden" href="/" as="/" colorBlue removeArrow />
    </div>
  );
};

export default ErrorPage;
